"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var rotateRight = (0, _styledComponents.keyframes)(["0%{transform:rotateZ(0deg);}100%{transform:rotateZ(359deg);}"]);

var Button = _styledComponents.default.button.withConfig({
  displayName: "Button",
  componentId: "sc-1hru96q-0"
})(["background-color:", ";border:", ";border-radius:", ";color:", ";cursor:pointer;line-height:16px;font-size:14px;font-weight:", ";min-height:40px;min-width:100%;padding:0 32px;text-align:center;transition:", ";&:hover{background-color:", ";border:", ";text-decoration:", ";}&:active{background-color:", ";text-decoration:", ";}&:focus{background-color:", ";text-decoration:", ";}", " ", " ", " ", " ", " ", " ", " ", ""], function (_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  return theme.luna && variant === 'primary' ? theme.luna.colors.ultramarine(60) : theme.button[variant].backgroundColor;
}, function (_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant;
  return theme.button[variant].border;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.luna ? '2rem' : '4px';
}, function (_ref4) {
  var theme = _ref4.theme,
      variant = _ref4.variant;
  return theme.button[variant].color;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fonts.weightRegular;
}, function (_ref6) {
  var theme = _ref6.theme,
      variant = _ref6.variant;
  return theme.button[variant].transition;
}, function (_ref7) {
  var theme = _ref7.theme,
      variant = _ref7.variant;
  return theme.luna && variant === 'primary' ? theme.luna.colors.ultramarine(90) : theme.button[variant].hover.backgroundColor;
}, function (_ref8) {
  var theme = _ref8.theme,
      variant = _ref8.variant;
  return theme.luna && variant === 'primary' ? theme.luna.colors.ultramarine(90) : theme.button[variant].hover.border;
}, function (_ref9) {
  var theme = _ref9.theme,
      variant = _ref9.variant;
  return theme.button[variant].hover.textDecoration;
}, function (_ref10) {
  var theme = _ref10.theme,
      variant = _ref10.variant;
  return theme.luna && variant === 'primary' ? theme.luna.colors.ultramarine(90) : theme.button[variant].active.backgroundColor;
}, function (_ref11) {
  var theme = _ref11.theme,
      variant = _ref11.variant;
  return theme.button[variant].active.textDecoration;
}, function (_ref12) {
  var theme = _ref12.theme,
      variant = _ref12.variant;
  return theme.luna && variant === 'primary' ? theme.luna.colors.ultramarine(90) : theme.button[variant].focus.backgroundColor;
}, function (_ref13) {
  var theme = _ref13.theme,
      variant = _ref13.variant;
  return theme.button[variant].focus.textDecoration;
}, function (_ref14) {
  var theme = _ref14.theme,
      working = _ref14.working,
      variant = _ref14.variant;
  return working && (0, _styledComponents.css)(["cursor:default;text-indent:-9999px;position:relative;&:after{animation:", " 1.25s infinite linear;border-radius:50%;border:", ";border-right-color:transparent;box-sizing:border-box;content:'';position:absolute;display:block;width:20px;height:20px;margin-top:-10px;margin-left:-10px;top:50%;left:50%;}}"], rotateRight, theme.button[variant].working.border);
}, function (_ref15) {
  var theme = _ref15.theme,
      selected = _ref15.selected,
      variant = _ref15.variant;
  return selected && (0, _styledComponents.css)(["background-color:", ";color:", ";border:none;:hover{background-color:", ";color:", ";border:none;text-decoration:none;}:focus{background-color:", ";}"], theme.luna ? (variant === 'primary' || variant === 'secondary') && theme.luna.colors.neutral(70) : theme.button[variant].selected.backgroundColor, theme.button[variant].selected.color, theme.luna ? (variant === 'primary' || variant === 'secondary') && theme.luna.colors.neutral(70) : theme.button[variant].selected.backgroundColor, theme.button[variant].selected.color, theme.button[variant].selected.backgroundColor);
}, function (_ref16) {
  var theme = _ref16.theme,
      disabled = _ref16.disabled,
      working = _ref16.working,
      variant = _ref16.variant;
  return disabled && !working && (0, _styledComponents.css)(["background-color:", ";color:", ";cursor:default;border:", ";:hover{background-color:", ";color:", ";border:", ";text-decoration:none;}"], theme.button[variant].disabled.backgroundColor, theme.button[variant].disabled.color, theme.button[variant].disabled.border, theme.button[variant].disabled.backgroundColor, theme.button[variant].disabled.color, theme.button[variant].disabled.border);
}, function (_ref17) {
  var theme = _ref17.theme,
      ghost = _ref17.ghost,
      variant = _ref17.variant;
  return ghost && (0, _styledComponents.css)(["background-color:", ";color:", ";border:", ";:hover{background-color:", ";color:", ";border:", ";text-decoration:none;}:focus{background-color:", ";}"], theme.button[variant].ghost.backgroundColor, theme.button[variant].ghost.color, theme.button[variant].ghost.border, theme.button[variant].ghost.backgroundColor, theme.button[variant].ghost.color, theme.button[variant].ghost.border, theme.button[variant].ghost.backgroundColor);
}, function (_ref18) {
  var theme = _ref18.theme,
      destructive = _ref18.destructive;
  return destructive && (0, _styledComponents.css)(["background-color:", ";color:", ";border:1px solid ", ";&:hover,&:focus{background-color:", ";border-color:", ";}"], theme.colors.system.error, theme.colors.neutral.white, theme.colors.system.error, theme.colors.system.dark.red, theme.colors.system.dark.red);
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.media.smallMedium((0, _styledComponents.css)(["& + &{margin-top:8px;}"]));
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.media.medium((0, _styledComponents.css)(["min-width:120px;& + &{margin-left:24px;}"]));
}, function (_ref21) {
  var theme = _ref21.theme;

  if (theme.luna) {}
});

Button.defaultProps = {
  children: '',
  type: 'button',
  variant: 'primary'
};
Button.propTypes = {
  /** Button Inner Text */
  children: _propTypes.default.node.isRequired,

  /** Additional button classes */
  className: _propTypes.default.string,

  /** State used on dark backgrounds */
  ghost: function ghost(props, propName) {
    if (props.ghost && props.primary) {
      return new Error('Invalid props combination: `' + propName + "` not allowed to be used with 'primary' at this time. Validation failed.");
    }

    if (props.ghost && typeof props.ghost !== 'boolean') {
      return new Error('Prop "ghost" should be a boolean');
    }
  },

  /** Use any button state [disabled|selected|working] */
  selected: _propTypes.default.bool,

  /**  Determines the look and feel of the button */
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'tertiary']).isRequired
};
var _default = Button;
exports.default = _default;
//# sourceMappingURL=Button.js.map